import dayjs, { Dayjs } from "dayjs";
import { BenefitResponse, BenefitType } from "../types/actionItem";
import { ActionModule, ActionModuleEmployeeResponse } from "../types/actionModule/actionModule";
import { ActionModuleInstanceResponse } from "../types/actionModule/actionModuleInstance";
import { PaginationParameters, PaginationResult, toQueryParameters } from "./Pagination";
import { CallResult, doApiGet, doApiPatch, doApiPost } from "./Requests";

export const actionModulesApi = {
  getActions: (): Promise<CallResult<ActionModule[]>> =>
    doApiGet<ActionModule[]>("/api/companies/current/actionmodules"),

  createAction: (actionData: any): Promise<CallResult<ActionModule>> =>
    doApiPost<any, ActionModule>("/api/companies/current/actionmodules", actionData),

  editAction: (id: number, actionData: Partial<ActionModule>): Promise<CallResult<void>> =>
    doApiPatch<Partial<ActionModule>, void>(`/api/companies/current/actionmodules/${id}`, actionData),

  getAction: (id: string): Promise<CallResult<ActionModule>> =>
    doApiGet<ActionModule>(`/api/companies/current/actionmodules/${id}`),

  getEmployeesForActionModule: (
    actionModuleId: number,
    pagination: PaginationParameters,
    startDate: Dayjs,
    endDate: Dayjs,
  ): Promise<CallResult<PaginationResult<ActionModuleEmployeeResponse>>> =>
    doApiGet<PaginationResult<ActionModuleEmployeeResponse>>(
      `/api/companies/current/actionmodules/${actionModuleId}/employees?${toQueryParameters(pagination)}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    ),

  getActionModuleInstances: (
    actionModuleId: number,
    employeeId: string,
    startDate: Dayjs,
    endDate: Dayjs,
  ): Promise<CallResult<ActionModuleInstanceResponse[]>> =>
    doApiGet<ActionModuleInstanceResponse[]>(
      `/api/companies/current/actionmodules/${actionModuleId}/employees/${employeeId}/instances?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    ),

  bookTransactionForActionModuleInstance: async (
    actionModuleId: string,
    actionModuleInstanceId: string
  ): Promise<CallResult<void>> => {
    return await doApiPost<null, void>(
      `/api/companies/current/actionmodules/${actionModuleId}/instances/${actionModuleInstanceId}/transactions/book`,
      null
    );
  },

  bookTransactionForActionModule: async (
    actionModuleId: string
  ): Promise<CallResult<void>> => {
    return await doApiPost<null, void>(
      `/api/companies/current/actionmodules/${actionModuleId}/transactions/book`,
      null
    );
  },
};